import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Container, Grid, Card, CardContent, Divider, Button, Tab, Tabs, FormControl, InputLabel, MenuItem, Select, IconButton, Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';

import AddIcon from '@mui/icons-material/Add';

const AddVOD = ({ handleClose }) => {
  const [tabValue, setTabValue] = useState(0);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [categories, setCategories] = useState([]);
  const [posterFile, setPosterFile] = useState(null);
  const [posterPreview, setPosterPreview] = useState('');
  const [landscapePosterFile, setLandscapePosterFile] = useState(null);
  const [landscapePosterPreview, setLandscapePosterPreview] = useState('');
  const [broadPosterFile, setBroadPosterFile] = useState(null);
  const [broadPosterPreview, setBroadPosterPreview] = useState('');
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [videos, setVideos] = useState([]);
  const [selectedVideoNames, setSelectedVideoNames] = useState(Array(videos.length).fill('No file chosen'));
  const [trailers, setTrailers] = useState([
    { Bitrate: '', url: '', audioTitle: '', qualityTitle: '', serverURL: '', order: '',subtitles:[] },
  ]);

  
  // Assuming you have a state for the uploaded video
const [uploadedVideo, setUploadedVideo] = useState(null);
  
  const [commonValues, setCommonValues] = useState({
    enable: '',
    title: '',
    description: '',
    poster: '',
    landscapePoster: '',
    broadPoster: '',
    disableCommenting: '',
    order: '',
    parentFolder: '',
    packages: '',
    mainCategory: '',
    additionalCategory: '',
  });
 
  const [metadataValues, setMetadataValues] = useState({
    duration: '',
    language: '',
    year: '',
    month: '',
    day: '',
    director: '',
    writer: '',
    acting: '',
    award: '',
    details: '',
    price: '',
    purchaseDuration: '',
    tags: [],
    ratings: '',
    imdbRatings: '',
  });

  // Function to handle metadata change
  const handleMetadataChange = (id, value) => {
    setMetadataValues((prevMetadata) => ({
      ...prevMetadata,
      [id]: value,
    }));
  }; 

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    // Handle the uploaded file as needed
    setUploadedVideo(file); // Update state with the uploaded file
  };


  
  // Generate arrays for days, months, and years
  const generateDays = () => Array.from({ length: 31 }, (_, i) => ({ value: (i + 1).toString(), label: (i + 1).toString() }));
  const generateMonths = () => [
    { value: 'January', label: 'January' },
    { value: 'February', label: 'February' },
    { value: 'March', label: 'March' },
    { value: 'April', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'June', label: 'June' },
    { value: 'July', label: 'July' },
    { value: 'August', label: 'August' },
    { value: 'September', label: 'September' },
    { value: 'October', label: 'October' },
    { value: 'November', label: 'November' },
    { value: 'December', label: 'December' },
  ];
  
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1900 + 1 }, (_, i) => ({
      value: (currentYear - i).toString(),
      label: (currentYear - i).toString(),
    }));
  };

  const days = generateDays();
  const months = generateMonths();
  const years = generateYears();
  const handleTagsChange = (e) => {
    const { value } = e.target;
    const tagsArray = value.split(',').map((tag) => tag.trim());
    setMetadataValues((prevMetadata) => ({
      ...prevMetadata,
      tags: tagsArray,
    }));
  };
  

 const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCommonChange = (id, value) => {
    setCommonValues({ ...commonValues, [id]: value });
  };
  

  // Function to handle poster image change
  const handlePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result; // This is of type ArrayBuffer
        if (typeof result === 'string') {
          setPosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setPosterFile(file);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
    handleMetadataChange(id, event.target.value);
  };
  

 // Function to handle Landscape Poster change
  const handleLandscapePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          setLandscapePosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setLandscapePosterFile(file);
    }
  };
   // Function to handle Broad Poster change
  const handleBroadPosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          setBroadPosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setBroadPosterFile(file);
    }
  };


  const handleAddTrailer = () => {
    const newTrailers = [
      ...trailers,
      { Bitrate: '', url: '', audioTitle: '', qualityTitle: '', serverURL: '', order: '',subtitles:[] },
    ];
    setTrailers(newTrailers);
  };

  const handleDeleteTrailer = (index) => {
    const updatedTrailers = [...trailers];
    updatedTrailers.splice(index, 1);
    setTrailers(updatedTrailers);
  };
  const handleTrailerChange = (index, updatedField) => {
    const updatedTrailers = [...trailers];
    updatedTrailers[index] = { ...updatedTrailers[index], ...updatedField };
    setTrailers(updatedTrailers);
  };
  

  const handleAddSubtitle = (index) => {
    const updatedTrailers = [...trailers];
    updatedTrailers[index].subtitles.push({ language: '', url: '' });
    setTrailers(updatedTrailers);
  };
  
  const handleSubtitleChange = (trailerIndex, subtitleIndex, e) => {
    const { name, value } = e.target;
    const updatedTrailers = [...trailers];
    updatedTrailers[trailerIndex].subtitles[subtitleIndex][name] = value;
    setTrailers(updatedTrailers);
  };

  const handleDeleteSubtitle = (trailerIndex, subtitleIndex) => {
    const updatedTrailers = [...trailers];
    if (
      updatedTrailers[trailerIndex].subtitles &&
      Array.isArray(updatedTrailers[trailerIndex].subtitles)
    ) {
      updatedTrailers[trailerIndex].subtitles.splice(subtitleIndex, 1);
      setTrailers(updatedTrailers);
    }
  };


  const handleSubtitleImageChange = (index, subtitleIndex, e) => {
    const file = e.target.files[0]; // Access the uploaded file
    const reader = new FileReader();
  
    reader.onloadend = () => {
      const imagePreviewUrl = reader.result; // Get the image URL
  
      // Update the state with the image preview URL
      const updatedTrailers = [...trailers];
      updatedTrailers[index].subtitles[subtitleIndex].imagePreview = imagePreviewUrl;
      setTrailers(updatedTrailers);
    };
  
    if (file) {
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  
  

// handle video file 


const handleVideoChange = (event, index) => {
  const file = event.target.files[0]; // Get the selected file

  // Update the video in the videos array at the specified index
  const updatedVideos = [...videos];
  updatedVideos[index] = file;
  setVideos(updatedVideos);

  // Update selected video names array to display the selected video's name
  const updatedVideoNames = [...selectedVideoNames];
  updatedVideoNames[index] = file ? file.name : 'No file chosen';
  setSelectedVideoNames(updatedVideoNames);

  // Reset the video name to 'No file chosen' if no file is selected
  if (!file) {
    updatedVideoNames[index] = 'No file chosen';
    setSelectedVideoNames(updatedVideoNames);
  } else {
    // Reset the video name to 'No file chosen' for the next index if adding a new video
    const nextIndex = index + 1;
    if (nextIndex < updatedVideoNames.length) {
      updatedVideoNames[nextIndex] = 'No file chosen';
      setSelectedVideoNames(updatedVideoNames);
    }
  }
};


const handleAddVideo = () => {
  // Add a new slot for a video file
  setVideos([...videos, null]);

  // Reset the video names for all slots to 'No file chosen'
  const updatedVideoNames = [...selectedVideoNames];
  updatedVideoNames.push('No file chosen'); // Add a new entry for the added video slot
  setSelectedVideoNames(updatedVideoNames);
};

  
const handleDeleteVideo = (index) => {
  const updatedVideos = videos.filter((_, i) => i !== index);
  setVideos(updatedVideos);

  // Update selectedVideoNames to match the updated videos array after deletion
  const updatedVideoNames = selectedVideoNames.filter((_, i) => i !== index);
  setSelectedVideoNames(updatedVideoNames);
};

  
  
  
  
  
/*Handle the dropdown for language and status */

useEffect(() => {
  fetchLanguages();
}, []);

const fetchLanguages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_LANGUAGES}`);
    console.log('Languages Response:', response); // Log the response object
    if (Array.isArray(response.data)) {
      setLanguages(response.data);
    } else {
      console.error('Invalid data format for languages:', response.data);
    }
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
};




 
  const handleSubmit = async () => {
    
  };


  
/*fetch channel List*/
useEffect(() => {
  fetchPackages();
}, []);

const fetchPackages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}`);
    if (Array.isArray(response.data)) {
      setPackages(response.data);
    } else {
      console.error('Invalid data format for packages:', response.data);
      // Handle this case according to your specific requirements
    }
  } catch (error) {
    console.error('Error fetching packages:', error);
    // Handle error, show message, etc.
  }
};
useEffect(() => {
  fetchCategories();
}, []);

//fetch categories 
const fetchCategories = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_CATEGORY}`);
    console.log(response.data); // Check the structure of response.data

    if (Array.isArray(response.data.applications)) {
      const categoryIds = response.data.applications.map(app => app.id);
      setCategories(categoryIds);
    } else {
      console.error('Invalid data format:', response.data);
      
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
    
  }
};





  return (
    <>
      <Helmet>
        <title>Advertisement Page</title>
      </Helmet>
      <Container maxWidth="lg" sx={{ marginTop: '20px' }}>
      <Grid container justifyContent="center">

      <Grid item xs={12} md={12}>
      <Card variant="outlined">
              {/* <Divider /> */}
              <CardContent>
                <Box sx={{ marginBottom: '20px' }}>
                  <Tabs value={tabValue} onChange={handleTabChange}>
                    
                    <Tab label="Metadata" />
                    <Tab label="Poster" />
                    <Tab label="Trailers" />
                    <Tab label="Video" />
                  </Tabs>
                  </Box>
              
                {/* {meta data value} */}
                      {tabValue === 0 && (
                        <Box mt={3}>
                          <Grid container spacing={2}>
                            
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="duration"
                                label="Duration"
                                value={metadataValues.duration}
                                onChange={(e) => handleInputChange(e, 'duration')}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                            
                            <TextField
                              required
                              id="language"
                              name="language"
                              select
                              value={selectedLanguage}
                              label="Language"
                              fullWidth
                              onChange={(e) => setSelectedLanguage(e.target.value)}
                            >
                              {languages.map((language) => (
                                <MenuItem key={language} value={language}>
                                {language}
                              </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                            <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel id="day-label">Day</InputLabel>
                            <Select
                              labelId="day-label"
                              id="day"
                              value={metadataValues.day}
                              onChange={(e) => handleMetadataChange('day', e.target.value)}
                                  >
                              {days.map((day) => (
                                <MenuItem key={day.value} value={day.value}>
                                  {day.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel id="month-label">Month</InputLabel>
                            <Select
                              labelId="month-label"
                              id="month"
                              value={metadataValues.month}
                              onChange={(e) => handleMetadataChange('month', e.target.value)}
                            >
                              {months.map((month) => (
                                <MenuItem key={month.value} value={month.value}>
                                  {month.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel id="year-label">Year</InputLabel>
                            <Select
                              labelId="year-label"
                              id="year"
                              value={metadataValues.year}
                              onChange={(e) => handleMetadataChange('year', e.target.value)}
                            >
                              {years.map((year) => (
                                <MenuItem key={year.value} value={year.value}>
                                  {year.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                             <Grid item xs={12} sm={6}>
                              <TextField
                                id="director"
                                label="Director"
                                value={metadataValues.director}
                                onChange={(e) => handleInputChange(e, 'director')}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="writer"
                                label="Writer"
                                value={metadataValues.writer}
                                onChange={(e) => handleInputChange(e, 'writer')}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <TextField
                                id="acting"
                                label="Acting"
                                value={metadataValues.acting}
                                onChange={(e) => handleInputChange(e, 'acting')}
                                fullWidth
                              />
                            </Grid>
                          <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="award"
                                      label="Award"
                                      value={metadataValues.award}
                                      onChange={(e) => handleInputChange(e, 'award')}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="details"
                                      label="Details"
                                      value={metadataValues.details}
                                      onChange={(e) => handleInputChange(e, 'details')}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="price"
                                      label="Price"
                                      value={metadataValues.price}
                                      onChange={(e) => handleInputChange(e, 'price')}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="purchaseDuration"
                                      label="Purchase Duration"
                                      value={metadataValues.purchaseDuration}
                                      onChange={(e) => handleInputChange(e, 'purchaseDuration')}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="tags"
                                      label="Tags"
                                      value={metadataValues.tags.join(', ')}
                                      onChange={handleTagsChange}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="ratings"
                                      label="Ratings"
                                      value={metadataValues.ratings}
                                      onChange={(e) => handleInputChange(e, 'ratings')}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      id="imdbRatings"
                                      label="IMDb Ratings"
                                      value={metadataValues.imdbRatings}
                                      onChange={(e) => handleInputChange(e, 'imdbRatings')}
                                      fullWidth
                                    />
                                  </Grid>
                               </Grid>
                        </Box>
                      )}
                     

                     {/* {poster Value} */}

                    {tabValue === 1 && (
                    <Box mt={3}>
                    <Grid container spacing={2}>
                       <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="enable-label">Enable</InputLabel>
                          <Select
                              labelId="enable-label"
                              id="enable"
                              value={commonValues.enable}
                              onChange={(e) => handleCommonChange('enable', e.target.value)}
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>
                           </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="title"
                          label="Title"
                          value={commonValues.title}
                          onChange={(e) => handleCommonChange('title', e.target.value)}

                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                      {/* Poster Image Upload */}
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="posterUpload"
                                  onChange={handlePosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="posterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    <span id="posterInputLabel">Choose Poster</span>
                                  </Button>
                                </label>
                                {/* Poster Image Preview */}
                                {posterPreview && (
                                  <img src={posterPreview} alt="Poster Preview" width="100" height="100" />
                                )}
                              </Grid>


                              {/* Landscape Poster Image Upload */}
                              <Grid item xs={12} sm={6}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="landscapePosterUpload"
                                  onChange={handleLandscapePosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="landscapePosterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    Choose Landscape Poster
                                  </Button>
                                </label>
                                {/* Landscape Poster Image Preview */}
                                {landscapePosterPreview && (
                                  <img
                                    src={landscapePosterPreview}
                                    alt="Landscape Poster Preview"
                                    width="100"
                                    height="100"
                                  />
                                )}
                              </Grid>

                              {/* Broad Poster Image Upload */}
                              <Grid item xs={12} sm={6}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="broadPosterUpload"
                                  onChange={handleBroadPosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="broadPosterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    Choose Broad Poster
                                  </Button>
                                </label>
                                {/* Broad Poster Image Preview */}
                                {broadPosterPreview && (
                                  <img
                                    src={broadPosterPreview}
                                    alt="Broad Poster Preview"
                                    width="100"
                                    height="100"
                                  />
                                )}
                              </Grid>


                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="description"
                          label="Description"
                          value={commonValues.description}
                          onChange={(e) => handleCommonChange('description', e.target.value)}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="disableCommenting-label">Disable Commenting</InputLabel>
                          <Select
                            labelId="disableCommenting-label"
                            id="disableCommenting"
                            value={commonValues.enable}
                            onChange={(e) => handleCommonChange('disableCommenting', e.target.value)}
                          >
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="parentFolder-label">Parent Folder</InputLabel>
                          <Select
                            labelId="parentFolder-label"
                            id="parentFolder"
                            value={commonValues.parentFolder}
                            onChange={(e) => handleCommonChange('parentFolder', e.target.value)}
                          >
                                  <MenuItem value="">Select Folder</MenuItem>
                                  <MenuItem value="FolderID1">Folder Name 1</MenuItem>
                                  <MenuItem value="FolderID2">Folder Name 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                              <TextField
                                required
                                id="package"
                                name="package"
                                select
                                value={selectedPackage}
                                label="Package"
                                fullWidth
                                onChange={(e) => setSelectedPackage(e.target.value)}
                              >
                                {packages.map((pkg) => (
                                  <MenuItem key={pkg.id} value={pkg.planName}>
                                    {pkg.planName}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>


                         <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="mainCategory-label">Main Category</InputLabel>
                          <Select
                            labelId="mainCategory-label"
                            id="mainCategory"
                            value={commonValues.mainCategory}
                            onChange={(e) => handleCommonChange('mainCategory', e.target.value)}
                          >
                                  <MenuItem value="">Select mainCategory</MenuItem>
                                  <MenuItem value="FolderID1">mainCategory 1</MenuItem>
                                  <MenuItem value="FolderID2">mainCategory 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>
                            
                            
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="additionalCategory-label">Additional Category</InputLabel>
                          <Select
                            labelId="additionalCategory-label"
                            id="additionalCategory"
                            value={commonValues.additionalCategory}
                            onChange={(e) => handleCommonChange('additionalCategory', e.target.value)}
                          >
                                  <MenuItem value="">Select additionalCategory</MenuItem>
                                  <MenuItem value="FolderID1">additionalCategory 1</MenuItem>
                                  <MenuItem value="FolderID2">additionalCategory 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>
                      </Grid>
                    </Box>
                  )}
                      

                  {/* Trailers Tab */}
                  {tabValue === 2 && (
                        <Grid container spacing={2}>
                          
                        {trailers.map((trailer, index) => (
                           <Grid container item spacing={2} key={index}>
                           <Box sx={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
                            
                           <Grid container spacing={2}>
                            <Grid item xs={6}>
                              
                            <TextField
                                name={`Bitrate-${index}`}
                                value={trailer.audioTitle}
                                label="Bitrate Title"
                                fullWidth
                                onChange={(e) => handleTrailerChange(index, e)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                            
                            <TextField
                              required
                              id="language"
                              name="language"
                              select
                              value={selectedLanguage}
                              label="Language"
                              fullWidth
                              onChange={(e) => setSelectedLanguage(e.target.value)}
                            >
                              {languages.map((language) => (
                                <MenuItem key={language} value={language}>
                                {language}
                              </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        
                                            
                        <Grid item xs={6}>
                              <TextField
                                name={`AudioTitle-${index}`}
                                value={trailer.audioTitle}
                                label="Audio Title"
                                fullWidth
                                onChange={(e) => handleTrailerChange(index, e)}
                              />
                            </Grid>
                            <Grid item xs={6}>
                            <FormControl fullWidth>
                              <InputLabel id={`qualityTitle-label-${index}`}>Quality Title</InputLabel>
                              <Select
                                labelId={`qualityTitle-label-${index}`}
                                id={`qualityTitle-${index}`}
                                value={trailer.qualityTitle || ''} // Ensure this value matches the state
                                onChange={(e) => handleTrailerChange(index, { qualityTitle: e.target.value })}
                              >
                                <MenuItem value="360">360(nHD)</MenuItem>
                                <MenuItem value="480">480(FWVGA)</MenuItem>
                                <MenuItem value="720">720(HD ready)</MenuItem>
                                <MenuItem value="1080">1080(FULL HD)</MenuItem>
                                <MenuItem value="1440">1440(WQXGA)</MenuItem>
                                <MenuItem value="2160">2160(4K UHD)</MenuItem>
                                <MenuItem value="4320">4320(8K UHD)</MenuItem>
                                {/* Add additional menu items as needed */}
                              </Select>
                            </FormControl>

                              </Grid>

                            <Grid item xs={6}>
                              <TextField
                                name={`ServerURL-${index}`}
                                value={trailer.serverURL}
                                label="Server URL"
                                fullWidth
                                onChange={(e) => handleTrailerChange(index, e)}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                name={`Order-${index}`}
                                value={trailer.order}
                                label="Order"
                                fullWidth
                                onChange={(e) => handleTrailerChange(index, e)}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <IconButton onClick={() => handleDeleteTrailer(index)}>
                                <DeleteIcon color="error" />
                              </IconButton>
                            </Grid>
                            </Grid>
                              </Box>
                              
                              


                             {/* Add Video */}
                             <Grid item xs={12}>
                             <Box sx={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
                      <Typography variant="h6" style={{ borderBottom: '1px solid #ccc', paddingBottom: '10px', marginBottom: '10px' }}>Add Video</Typography>
                  <Grid container spacing={2}>
    {videos.map((video, index) => (
      <Grid container item spacing={2} key={index}>
        {/* Video File Upload */}
        <Grid item xs={6}>
          <input
            type="file"
            accept="video/*"
            id={`videoUpload-${index}`}
            onChange={(e) => handleVideoChange(e, index)}
            style={{ display: 'none' }}
          />
          <label htmlFor={`videoUpload-${index}`}>
            <Button
              variant="outlined"
              component="span"
              color="primary"
              sx={{ textTransform: 'none' }}
            >
              Upload Video
            </Button>
          </label>
        </Grid>
        {/* Display selected video name */}
        <Grid item xs={6}>
          <p>{selectedVideoNames[index]}</p>
        </Grid>
     

          {/* Additional fields related to the video, similar to subtitles */}
          {/* ... (fields for bitrate, language, title, serverURL, order, etc.) */}

          <Grid item xs={2}>
            <IconButton onClick={() => handleDeleteVideo(index)}>
              <DeleteIcon color="error" />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      {/* Button to add a new video */}
      <Grid item xs={12}>
        <Grid container justifyContent="center">
          <div style={{ textAlign: 'center', width: '100%' }}>
            <Typography variant="subtitle1">Add Video</Typography>
            <IconButton color="primary" onClick={handleAddVideo}> 
              <AddIcon />
            </IconButton>
          </div>
        </Grid>
      </Grid>
    </Grid>
    </Box>
    </Grid>
                            
                            
                             {/* Subtitles */}
                                  <Grid item xs={12}>
                                  <Typography variant="h6">Subtitles</Typography>
                                    {/* Subtitle fields */}
                                    <Box sx={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
                                    {trailer.subtitles.map((subtitle, subtitleIndex) => (
                                      <Grid container item spacing={2} key={subtitleIndex}>
                                        {/* Fields for each subtitle */}
                                        <Grid item xs={12} sm={6}>
                                                      
                                              <TextField
                                                required
                                                id="language"
                                                name="language"
                                                select
                                                value={selectedLanguage}
                                                label="Language"
                                                fullWidth
                                                onChange={(e) => setSelectedLanguage(e.target.value)}
                                              >
                                                {languages.map((language) => (
                                                  <MenuItem key={language} value={language}>
                                                  {language}
                                                </MenuItem>
                                                ))}
                                              </TextField>
                                            </Grid>
                                       <Grid item xs={6}>
                                          {/* Subtitle Image Upload */}
                                          <input
                                            type="file"
                                            accept="image/*"
                                            id={`subtitleImageUpload-${index}-${subtitleIndex}`}
                                            onChange={(e) => handleSubtitleImageChange(index, subtitleIndex, e)}
                                            style={{ display: 'none' }}
                                          />
                                          <label htmlFor={`subtitleImageUpload-${index}-${subtitleIndex}`}>
                                            <Button
                                              variant="outlined"
                                              component="span"
                                              color="primary"
                                              sx={{ textTransform: 'none' }}
                                            >
                                              Upload Image
                                            </Button>
                                          </label>
                                          {/* Display uploaded image */}
                                          {subtitle.imagePreview && (
                                            <img src={subtitle.imagePreview} alt="Subtitle Image Preview" width="100" height="100" />
                                          )}
                                        </Grid>


                            <Grid item xs={2} sm={2}>
                            <IconButton onClick={() => handleDeleteSubtitle(index, subtitleIndex)}>
                             <DeleteIcon color="error" />
                              </IconButton>
                               </Grid>
                         {/* Other subtitle fields */}
                                  </Grid>
                                   ))}
                            
                              {/* Button to add a new subtitle */}
                              <Grid item>
                                  <Typography variant="subtitle1">Add Subtitle</Typography>
                                </Grid>
                                  <IconButton color="primary" onClick={() => handleAddSubtitle(index)}>
                                  <AddIcon />
                                  </IconButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            ))}



                   {/* Button to add a new trailer */}
                    <Grid item xs={12}>
                      
                      <Grid container justifyContent="center">
                        
                        <div style={{ textAlign: 'center', width: '100%' }}>
                          <Typography variant="subtitle1">Add Trailer</Typography>
                          <IconButton color="primary" onClick={handleAddTrailer}>
                            <AddIcon />
                          </IconButton>
                        </div>
                      </Grid>
                    </Grid>
                    </Grid>
                    )}


 {/* {Video Upload} */}
 {tabValue === 3 && (
        <Box mt={3}>
          <Grid container spacing={2}>
            {/* Add styling to make it more attractive */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Upload Your Video
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <input
                style={{ display: 'none' }} // Hide the default file input style
                id="video-upload"
                type="file"
                accept="video/*"
                onChange={handleVideoUpload}
              />
              <label htmlFor="video-upload">
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  fullWidth
                >
                  Choose a Video File
                </Button>
              </label>
            </Grid>
            {/* Display the uploaded video information */}
            {uploadedVideo && (
              <Grid item xs={12}>
                <Typography variant="body1">
                  Uploaded Video: {uploadedVideo.name}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}


                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    sx={{ marginRight: '10px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AddVOD;
